import { phoneNumberInput } from '@/constants/form_inputs';

export const PhoneNumbersFormFields = [
  {
    ...phoneNumberInput,
    name: 'phoneNumber',
    label: 'Phone number',
    rules: {
      ...phoneNumberInput.rules,
      required: 'This field is required.',
    },
    grid: {
      md: 3,
    },
  },
  {
    name: 'phoneNumberExt',
    label: 'Phone extension input',
    rules: {
      maxLength: {
        value: 5,
        message: 'Phone extension cannot exceed 5 digits.',
      },
    },
    grid: {
      md: 2.6,
    },
  },
];
